/*
  UIkit 
/*---------------------------------------*/
import 'uikit/dist/css/uikit.css'
import UIkit from 'uikit/dist/js/uikit'
import Icons from 'uikit/dist/js/uikit-icons'
UIkit.use(Icons)


